import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import AreaAnnotationData from "../model/sceneObjectData/AreaAnnotationData";
import GeometryMoveEditCmd from "./GeometryMoveEditCmd";
import { buildPolygonRefAxes } from "./commandHelpers/polygonRefAxes";

/**
 * Move edit for an AreaAnnotation profile vertex. In addition to the default
 * single-origin reference axes, snaps to world X/Y/Z axes through every profile
 * point, so the moved vertex can align with any other vertex of the polygon.
 * The vertex must stay within the profile's plane, so — unlike other geometry
 * edit commands — plane switching is not offered here.
 */
export default class GeometryPolygonEndpointMoveCmd extends GeometryMoveEditCmd {

    constructor(
        commandStack: CommandStack,
        canvasInputListener: ICanvasInputListener,
        document: Document,
    ) {
        super(commandStack, canvasInputListener, document);
        this.id = CommandIdEnum.GeometryPolygonEndpointMove;
    }

    override activate(): void {
        const data = this.ownerSceneObject.data as AreaAnnotationData;
        // data.points are in local (parent) space; convert to world space to match
        // editHandleData.position/plane, which SelectCmd.showHandles() already transforms.
        const worldPoints = data.points.map(p =>
            data.placement.location.clone().add(p).applyMatrix4(this.parentWorldMatrix)
        );

        this.refAxisHelper.enable();
        this.refAxisHelper.setAxes(buildPolygonRefAxes(worldPoints, this.modelRotationOffset, true));

        if (this.editHandleData.plane) {
            this.showPlaneGrid(this.editHandleData.position.clone(), this.editHandleData.plane.normal.clone());
        }
    }

    override deactivate(): void {
        this.disableReferenceLine();
    }
}
